import React from "react";

export const UserMenuIcon: React.FC = () => {
  return (
    <>
      <svg
        width="18px"
        height="17px"
        viewBox="0 0 18 17"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <desc>Created with sketchtool.</desc>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="CareGEM-Notifications-V1.1"
            transform="translate(-1284.000000, -20.000000)"
            fill="#212B40"
          >
            <g id="main-header-normal">
              <g id="header">
                <g
                  id="profile-icon-button"
                  transform="translate(1272.000000, 8.000000)"
                >
                  <g id="Group-9">
                    <path
                      d="M21,21.683509 C21.9755179,21.683509 23.0629641,21.8354316 24.2623713,22.1392814 C25.6057073,22.4751155 26.6931535,22.9228874 27.5247425,23.4826108 C28.5162525,24.1542788 29.012,24.8979001 29.012,25.713497 L29.012,28.712 L12.988,28.712 L12.988,25.713497 C12.988,24.8979001 13.4837475,24.1542788 14.4752575,23.4826108 C15.3068465,22.9228874 16.3942927,22.4751155 17.7376287,22.1392814 C18.9370359,21.8354316 20.0244821,21.683509 21,21.683509 Z M21,12.688 C21.7196443,12.688 22.3833063,12.8679084 22.991006,13.2277305 C23.5987056,13.5875527 24.0824593,14.0793023 24.4422814,14.702994 C24.8021036,15.3266858 24.982012,15.9983437 24.982012,16.717988 C24.982012,17.4376323 24.8021036,18.1012944 24.4422814,18.708994 C24.0824593,19.3166937 23.5987056,19.8004473 22.991006,20.1602695 C22.3833063,20.5200916 21.7196443,20.7 21,20.7 C20.2803557,20.7 19.6166937,20.5200916 19.008994,20.1602695 C18.4012944,19.8004473 17.9175407,19.3166937 17.5577186,18.708994 C17.1978964,18.1012944 17.017988,17.4376323 17.017988,16.717988 C17.017988,15.9983437 17.1978964,15.3266858 17.5577186,14.702994 C17.9175407,14.0793023 18.4012944,13.5875527 19.008994,13.2277305 C19.6166937,12.8679084 20.2803557,12.688 21,12.688 Z M21,23.6025509 C20.0884505,23.6025509 19.1209432,23.7384817 18.0974491,24.0103473 C17.2178838,24.2502287 16.4662666,24.5380822 15.8425749,24.8739162 C15.2188831,25.2097502 14.9070419,25.4896077 14.9070419,25.713497 L14.9070419,26.7929581 L27.0929581,26.7929581 L27.0929581,25.713497 C27.0929581,25.4896077 26.7811169,25.2097502 26.1574251,24.8739162 C25.5337334,24.5380822 24.7821162,24.2502287 23.9025509,24.0103473 C22.8790568,23.7384817 21.9115495,23.6025509 21,23.6025509 Z M21,14.6070419 C20.4082925,14.6070419 19.9085469,14.8109381 19.5007485,15.2187365 C19.0929501,15.626535 18.8890539,16.1262805 18.8890539,16.717988 C18.8890539,17.3096956 19.0929501,17.8014451 19.5007485,18.1932515 C19.9085469,18.5850578 20.4082925,18.7809581 21,18.7809581 C21.5917075,18.7809581 22.0914531,18.5850578 22.4992515,18.1932515 C22.9070499,17.8014451 23.1109461,17.3096956 23.1109461,16.717988 C23.1109461,16.1262805 22.9070499,15.626535 22.4992515,15.2187365 C22.0914531,14.8109381 21.5917075,14.6070419 21,14.6070419 Z"
                      id=""
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};
